import React from 'react';
import { Theme } from '@simplybenefits/sb-ui-library';
import { Grid } from '@mui/material';

/**
 * Reusable content block wrapper component for perks pages
 */
const ContentBlock = ({ children, customStyle }) => (
    <Grid
        container
        sx={{
            backgroundColor: Theme.colors.surface,
            boxShadow: '0px 0px 10px 1px rgba(151, 151, 151, 0.15)',
            padding: '20px 40px',
            borderRadius: '8px',
            marginBottom: '50px',
            minWidth: 0,
            ...customStyle
        }}
    >
        {children}
    </Grid>
);

export default ContentBlock;